import Vue from "vue";
import App from "./App.vue";
import animate from "animate.css";
import clipboard from "clipboard";
//注册到vue原型上
Vue.prototype.clipboard = clipboard;
Vue.use(animate);

Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount("#app");
